/* eslint-disable no-unused-vars */
import React from 'react';
import { Paper, Tooltip, Typography, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { customTheme } from '../customTheme';
// import { vehicleSvgs } from "../sharedData";
import Skeleton from '@material-ui/lab/Skeleton';
//import Chart from "react-apexcharts";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReactApexChart from 'react-apexcharts';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import downArrow from '../images/down.png'
import sideArrow from '../images/side.png'
import helmetImg from '../images/helmet.png'


const useStyles = makeStyles({
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 20,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    flexContainer: {
        display: 'flex',
        alignItems:"center",
    },
    summaryVehicleIcon: {
        width: 18,
        height: 18,
    },
    summaryHelmetIcon: {
        width: 16,
        height: 16,
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 13
    }
});

const donutColors = ['#FC7668', '#3EF791', '#FFCBA5', '#FFA7A6', '#92EEFC', '#5E8DD3', '#FFA726']

const renderTotalAmount = (paymentDistributions, data) => {
    if (paymentDistributions === 'PM') {
        return { totalAmount: data.amount + data.monthlyPass_total_amount, label1: "POS", label2: "Monthly Pass", label1Amount: data.amount, label2Amount: data.monthlyPass_total_amount }
    }
    if (paymentDistributions === 'PP') {
        return { totalAmount: data.amount + data.monthlyPass_total_amount, label1: "POS", label2: "Permits", label1Amount: data.amount, label2Amount: data.permitPayments_total_amount }
    }
    if (paymentDistributions === 'MP') {
        return { totalAmount: data.permitPayments_total_amount + data.monthlyPass_total_amount, label2: "Permits", label1: "Monthly Pass", label2Amount: data.permitPayments_total_amount, label1Amount: data.monthlyPass_total_amount }
    }
    if (paymentDistributions === 'PMP') {
        return { totalAmount: data.amount + data.monthlyPass_total_amount + data.permitPayments_total_amount, label1: "POS", label2: "Monthly Pass", label3: "Permits", label1Amount: data.amount, label2Amount: data.monthlyPass_total_amount, label3Amount: data.permitPayments_total_amount }
    }
}

export default function VehicleSummaryCard({ title, showTileOnZeroAmount = true, value, valueFormatter = value => value, valueDescription, valueDescriptionTooltip, distributedValues, distributedLabels, distributedIcons, distributedValueDescription, distributionCount, vehicleCount, loading, isPaymentType, distributedCount, distributedAmount, paymentDistributionsData, details, VehiclesVisitor, VehiclesPass, valueDescriptionVisitor,valueDescriptionPass, distributedValuesVisitor,distributedValuesPass, distributedValueDescriptionVisitor, distributedValueDescriptionPass, handlePaymentTiles, handleTilesClick,isActive, style}) {
    const classes = useStyles();
    const [paymentDistributions] = React.useState(sessionStorage.getItem("payment_distributions"));
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedOption, setSelectedOption] = React.useState("Visitor + Pass");
    const [selectedValue, setSelectedValue] = React.useState(value); // Default value
    const [exitedselectedValue, setExitedSelectedValue] = React.useState(valueDescription); // Default value
    const [enteredValues, setEnteredValues] = React.useState(distributedValues); // Default value
    const [distributedValue, setDistributedValue] = React.useState(distributedValueDescription); // Default value

    React.useEffect(() => {
        setSelectedValue(value);
        setExitedSelectedValue(valueDescription);
        setEnteredValues(distributedValues);
        setDistributedValue(distributedValueDescription);
    }, [value,valueDescription,distributedValues,distributedValueDescription]);

  
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    if(!showTileOnZeroAmount) return null;

    return <>
        {paymentDistributionsData ?
            <div onClick={handlePaymentTiles} style={{ cursor: 'pointer'}}  >
                <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px", ...style }}>
                    <div style={{ flex: 1 }}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography className={classes.title}>{title}</Typography>
                                <button style={{ background: "none", border: "none", cursor: "pointer" }} onClick={handlePaymentTiles}><Typography className={classes.title} style={{ backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "4px 12px", borderRadius: 5, fontSize: 10 }}>Detail</Typography></button>
                            </div>
                            {
                                !loading ?
                                    <div style={{ display: "flex" }}>
                                        <Typography className={classes.mainValue}>₹ {renderTotalAmount(paymentDistributions, paymentDistributionsData)['totalAmount']}</Typography>
                                    </div>
                                    :
                                    <Skeleton variant="text" height={30} width="34%" />
                            }
                        </div>
                        <div className={classes.twoColumnGrid} style={{ gridRowGap: paymentDistributionsData ? 3 : 0 }}>
                            {paymentDistributionsData && <>

                                {(paymentDistributions === "PM" || paymentDistributions === "PP" || paymentDistributions === "MP") &&
                                    <>
                                        <div className={classes.flexContainer}>
                                            <Typography className={classes.paymentSummaryBoxLabel1}>{renderTotalAmount(paymentDistributions, paymentDistributionsData)["label1"]} :</Typography>
                                            <Typography className={classes.summaryBoxValue1} style={{ flex: 1, textAlign: "right", marginLeft: 5 }}>{`₹ ${renderTotalAmount(paymentDistributions, paymentDistributionsData)['label1Amount']}`}</Typography>
                                        </div>
                                        <div className={classes.flexContainer}>
                                            <Typography className={classes.paymentSummaryBoxLabel1}>{renderTotalAmount(paymentDistributions, paymentDistributionsData)['label2']} :</Typography>
                                            <Typography className={classes.summaryBoxValue1} style={{ flex: 1, textAlign: "right", marginLeft: 5 }}>{`₹ ${renderTotalAmount(paymentDistributions, paymentDistributionsData)['label2Amount']}`}</Typography>
                                        </div>
                                    </>
                                }

                                {paymentDistributions === "PMP" &&
                                    <>
                                        <div className={classes.flexContainer}>
                                            <Typography className={classes.paymentSummaryBoxLabel1}>{renderTotalAmount(paymentDistributions, paymentDistributionsData)['label1']} :</Typography>
                                            <Typography className={classes.summaryBoxValue1} style={{ flex: 1, textAlign: "right", marginLeft: 5 }}>{`₹ ${renderTotalAmount(paymentDistributions, paymentDistributionsData)['label1Amount']}`}</Typography>
                                        </div>
                                        <div className={classes.flexContainer}>
                                            <Typography className={classes.paymentSummaryBoxLabel1}>{renderTotalAmount(paymentDistributions, paymentDistributionsData)['label2']} :</Typography>
                                            <Typography className={classes.summaryBoxValue1} style={{ flex: 1, textAlign: "right", marginLeft: 5 }}>{`₹ ${renderTotalAmount(paymentDistributions, paymentDistributionsData)['label2Amount']}`}</Typography>
                                        </div>
                                        <div className={classes.flexContainer}>
                                            <Typography className={classes.paymentSummaryBoxLabel1}>{renderTotalAmount(paymentDistributions, paymentDistributionsData)['label3']} :</Typography>
                                            <Typography className={classes.summaryBoxValue1} style={{ flex: 1, textAlign: "right", marginLeft: 5 }}>{`₹ ${renderTotalAmount(paymentDistributions, paymentDistributionsData)['label3Amount']}`}</Typography>
                                        </div>
                                    </>
                                }
                            </>
                            }
                        </div>
                    </div>
                </Paper>
            </div>
        :   
            <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 15px", cursor: details ? "pointer" : "", outline: isActive ? "2px solid #16CC69" : "", ...style }} onClick={handleTilesClick}>
                <div style={{ flex: 1 }}>
                    <div>
                        {details ?
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography className={classes.title}>{title}</Typography>
                                
                                <div style={{display:"flex", justifyContent:"center", alignItems:"center", minWidth: 40, backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "1px 12px", borderRadius: 2, fontSize: 9 }}>
                                <div style={{marginRight: 4}}>Detail</div>
                                <img src={isActive ? downArrow : sideArrow} alt='arrow' />
                                </div>
                            </div>
                            : (
                                <div
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                >
                                    <Typography className={classes.title}>{title}</Typography>
                                </div>
                            )
                        }
                        {
                            !loading ?
                                <div style={{ display: "flex" }}>
                                    <Typography className={classes.mainValue}>{valueFormatter(selectedValue)}</Typography>
                                    <div style={{ display: "flex", justifyContent:"flex-end", alignItems:"flex-end" }}>
                                        {valueDescription && <div style={{ fontSize: 10, margin: "5px", color:"#18CC69", fontFamily:"Poppins-SemiBold" }}>{exitedselectedValue}</div>}
                                        {/* {valueDescriptionTooltip && <Tooltip arrow title={valueDescriptionTooltip} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 16, color: "#888" }} /></Tooltip>} */}
                                    </div>
                                </div>
                                :
                                <Skeleton variant="text" height={30} width="34%" />
                        }
                    </div>

                        {
                            !loading ? distributedLabels.map((dL, i) => (
                                <div key={dL} className={classes.flexContainer}>
                                    <div style={{display:"flex"}}>
                                    <img className={dL === "Helmet" ? classes.summaryHelmetIcon : classes.summaryVehicleIcon} src={dL === "Helmet" ? helmetImg : distributedIcons[i]} alt={dL} />
                                    <Typography className={classes.summaryBoxLabel1}>{dL === "Bike/Scooter" ? "Bike": dL}:</Typography>
                                    </div>
                                    <div style={{ flex: 1, display: "flex", justifyContent:"flex-end", alignItems:"flex-end", flexWrap: "wrap" }}>
                                        <Typography className={classes.summaryBoxValue1}>{valueFormatter(enteredValues[i])}</Typography>
                                        {distributedValueDescription && <div style={{marginLeft: 4, fontSize: 8, color:"#334D6E", fontFamily:"Poppins-Medium" }}>{distributedValue[i]}</div>}
                                    </div>
                                </div>
                            )) :
                            ["45%", "40%", "35%"].map((width, index) => (
                                <Skeleton variant="text" width={width} height={18} key={index} />
                            ))
                        }
        
                </div>

                {isPaymentType && <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginRight: -20 }}>
                    <ReactApexChart
                        series={value ? distributedCount : [1]}
                        type="donut" 
                        width={100}
                        height={100}
                        options={{
                            dataLabels: {
                                enabled: false
                            },
                            colors: value ? [...donutColors] : ['#F4F4F4'],
                            chart: {
                                type: 'donut',
                                fontFamily: "Poppins-Regular",
                                width: 100,
                            height: 100,
                            },
                            legend: {
                                show: false
                            },
                            tooltip: {
                                enabled: true,
                                style: {
                                    fontSize: '12px',
                                    fontFamily: "Poppins-Regular"
                                },
                                marker: {
                                    show: true,
                                },
                                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                                    if (sessionStorage.getItem("vehicle_summary_mask") === "1") return '-'
                                    let selected = series[seriesIndex]
                                    return value ? `${distributedLabels[seriesIndex]}: ${selected} | Amount : ₹ ${distributedAmount[seriesIndex]}` : ''
                                }
                            },
                            responsive: [{
                                breakpoint: 480,
                                options: {
                                  chart: {
                                    width: 100
                                  },
                                  legend: {
                                    position: 'bottom'
                                  }
                                }
                              }]
                        }}
                    />
                </div>}
            </Paper>
        }
    </> ;
}